import { styled } from '@innowise-group/mui-kit';

export const ConditionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 0.75rem;
  row-gap: 1.5rem;
  padding-top: 0.75rem;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FieldsGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

export const GroupLabel = styled.span`
  color: ${({ theme }) => theme.palette.general.lightGrey[70]};
  ${({ theme }) => theme.fonts.primary[60]}
`;

export const LabelWithIconWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
